// extracted by mini-css-extract-plugin
export var content = "layout-module--content--HZWLW";
export var info_page = "layout-module--info_page--O8vZb";
export var layout = "layout-module--layout--GbV5x";